import {Toaster} from "react-hot-toast";
import {Input, notify, ShowInfo} from "../utils";
import {FormProvider, useForm} from "react-hook-form";
import {useState} from "react";
import {apiClient} from "../../api/ApiClient";
import GovahitIcon2 from "../icons/GovahitIcon2";
import {leaderLogin} from "../../api/LeaderPortalApi";
import {setLeaderToken} from "../redux/actions/LeaderPortalAction";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

export default function LeaderLogin() {

    const [isSubmitted, setIsSubmitted] = useState(false);
    const dispatch = useDispatch();
    const methods = useForm();
    const navigate = useNavigate();

    const onSubmit = methods.handleSubmit(data => {
        setIsSubmitted(true);

        const adminData = {
            "username": data.username,
            "password": data.password
        }

        leaderLogin(adminData).then(response => {

            if(response.data.token){
                const jwtToken ='Bearer ' + response.data.token

                apiClient.interceptors.request.use(
                    (config) => {
                        config.headers.Authorization = jwtToken
                        return config
                    }
                )
                dispatch(setLeaderToken({
                    token: response.data.token,
                    refreshToken: response.data.refreshToken,
                    tokenExpiresIn: response.data.tokenExpiresIn,
                    refreshTokenExpiresIn: response.data.refreshTokenExpiresIn,
                }))

                setIsSubmitted(false)

                navigate('/leader/main')
            }else{
                setIsSubmitted(false)
                notify('کاربر یافت نشد.')
            }

        }).catch(error => {
            if(error.code == 'ERR_NETWORK') {
                notify('ارتباط با شبکه قطع است. اتصال اینترنت خود را بررسی کنید.')
            }else if(error?.response?.data?.message) {
                notify(error?.response?.data?.message)
            }

            setIsSubmitted(false)
        })

    })
    return(
        <div className={`login-leader-bg`}>
            <div className={`login-leader-div`}>

                <div className={`d-flex justify-content-center mt-4 pt-2`}>
                    <GovahitIcon2 />
                    <div className={`me-2`}>
                        <p className={`govahit-title`} style={{fontSize: "1.5rem"}}>گواهیت</p>
                        <p className={`panel-text`} style={{fontSize: "1.1rem"}}>پنل ادمین سامانه</p>
                    </div>
                </div>

                <div>
                    <Toaster/>

                    <FormProvider {...methods}>
                        <form
                            onSubmit={e => e.preventDefault()}
                            noValidate
                            className="container"
                        >
                            <Input
                                isWidth100={true}
                                lable_text="نام کاربری"
                                type="text"
                                name="username"
                                placeholder="نام کاربری خو را وارد کنید"
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا نام کاربری خود را وارد کنید',
                                    },
                                }}
                            />

                            <Input
                                isWidth100={true}
                                lable_text="کلمه عبور"
                                type="password"
                                name="password"
                                placeholder="کلمه عبور خود را وارد کنید"
                                validation={{
                                    required: {
                                        value: true,
                                        message: 'لطفا کلمه عبور خود را وارد کنید',
                                    },
                                }}
                            />

                            <div className='row justify-content-center my-2 '>
                                <div className='col-12'>
                                    <button
                                        onClick={onSubmit}
                                        className='btn w-100 text-form-button'
                                        style={{"background": "#044448"}}
                                        disabled={isSubmitted}>
                                        ورود
                                    </button>
                                </div>
                            </div>
                        </form>
                    </FormProvider>


                    {isSubmitted && (
                        <div className="loading-overlay">
                            <div className="loading-content">
                                <div className="spinner"></div>
                                <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </div>
    )
}